import React from 'react';
import { BiCheckbox } from 'react-icons/bi';
import { FiSearch } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';

const MembersSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { path: '/members/members-home', label: 'Dashboard' },
    { path: '/members/members-orders', label: 'Orders' },
    { path: '/members/members-downloads', label: 'Downloads' },
    { path: '/members/members-addresses', label: 'Addresses' },
    { path: '/members/members-payment-methods', label: 'Payment Methods' },
    { path: '/members/members-account-details', label: 'Account Details' },
  ];

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('member_token');
      if (token) {
        await axios.post('https://backend.dlapakistan.com/api/members/logout/', {}, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
      }
    } catch (error) {
      console.log('Logout API error:', error);
    }
    
    localStorage.removeItem('member_token');
    localStorage.removeItem('member_data');
    
    if (axios.defaults.headers.common['Authorization']) {
      delete axios.defaults.headers.common['Authorization'];
    }
    
    Swal.fire({
      icon: 'success',
      title: 'Signed Out',
      text: 'You have been signed out successfully.',
      timer: 2000,
      showConfirmButton: false,
    });
    
    navigate('/members/members-area');
  };

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="w-full bg-[#ffffff] p-4 md:p-5 rounded-lg shadow-sm h-fit overflow-x-auto">
      <div className="bg-[#70B444] text-white p-3 text-center mb-4 rounded">
        <h3 className="text-base lg:text-lg font-semibold">
          My Account
        </h3>
      </div>

      {/* Navigation Items */}
      <div className="space-y-0 max-h-[500px] overflow-y-auto overflow-x-hidden pr-1">
        {menuItems.map((item, index) => (
          <div
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex items-center justify-between py-2.5 px-2 text-sm lg:text-base cursor-pointer
              text-[#70B444] font-medium hover:bg-[rgba(112,180,68,0.1)] transition-colors
              ${
                index < menuItems.length - 1
                  ? "border-b border-gray-200"
                  : ""
              }
              ${
                isActive(item.path)
                  ? "bg-[rgba(112,180,68,0.1)] border-l-4 border-l-[#70B444] pl-1.5"
                  : ""
              }`}
          >
            <div className="flex items-center flex-1 min-w-0">
              <BiCheckbox className="mr-2 text-lg flex-shrink-0 min-w-[24px]" />
              <span className="break-words leading-tight truncate" title={item.label}>
                {item.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembersSidebar;